import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core'
import { StoreService } from '../../service/store.service'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { CompanyStructureTableComponent } from '../company-structure-table/company-structure-table.component'
import { CompanyStructurePictureComponent } from '../company-structure-picture/company-structure-picture.component'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material'

@Component({
  selector: 'app-company-structure-executive-summary',
  templateUrl: './company-structure-executive-summary.component.html',
  styleUrls: ['./company-structure-executive-summary.component.scss']
})
export class CompanyStructureExecutiveSummaryComponent implements OnInit {
  @Input() companyProfile: any
  @Input() printPage
  @Input() isFullFactSheet
  @ViewChild(CompanyStructureTableComponent)
  companyStructureTableComponent: CompanyStructureTableComponent
  @ViewChild(CompanyStructurePictureComponent)
  companyStructurePictureComponent: CompanyStructurePictureComponent


  subscription: Subscription
  symbol
  companyStructureFilename
  yearF56
  showData
  getObj = []
  isCompanyStructure = true
  hiddenTable = false
  hiddenPicture = false
  isAE

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private authorization: AuthorizeService
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.yearF56 = response['yearF56']
        this.companyStructureFilename = response['companyStructureFilename']
        this.isAE = response['ae']
        this.getFactsheetFlagBySecuritySymbol(this.symbol)
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  emptyCompanyFilename() {
    return (this.companyStructureFilename === null)
  }

  getFactsheetFlagBySecuritySymbol(symbol) {
    // this.hiddenTable = true
    // this.hiddenPicture = true

    this.cpmService.getFactsheetFlagBySymbol(symbol).subscribe(factsheet => {
      switch (factsheet.compStructureFlag) {
        case 'Table':
          this.hiddenTable = false // --> true
          this.hiddenPicture = true // --> false
          break
        case 'File':
          this.hiddenTable = true // --> false
          this.hiddenPicture = false // --> true
          break
        default:
          this.hiddenTable = true // --> true
          this.hiddenPicture = false // --> false
          break
      }
    })
  }

  flagChange(event) {
    this.getFactsheetFlagBySecuritySymbol(this.symbol)
  }

  flagPicChange(event) {
    this.getFactsheetFlagBySecuritySymbol(this.symbol)
  }

  uploadFile() {
    this.hiddenPicture = false
    this.companyStructurePictureComponent.fileUpload()
  }

  setEditFlag() {
    this.hiddenPicture = true
    this.hiddenTable = false
    this.companyStructureTableComponent.setEdit()
  }

  getYearF56() {
    if (this.yearF56 === null) {
      return null
    } else if (this.yearF56 !== null) {
      return '(56-1 ปี ' + this.yearF56 + ')'
    }
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListCompanyStr')
      .removeClass('show')
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-structure-executive-summary/company-structure-executive-summary.component.ts